/* eslint-disable max-classes-per-file */

export class HibouError extends Error {
  public readonly headline: string | undefined;
  public readonly advice: string | undefined;
  public readonly allowReload: boolean = false;

  public constructor(msg: string) {
    super(msg);
    this.name = 'HibouError';
  }
}

export class NotFoundError extends HibouError {
  public override readonly headline = 'Service not found';

  public constructor(location: string) {
    super(`No visualization service found at ${location}`);
    this.name = 'NotFoundError';
  }
}

export class SearchParamError extends HibouError {
  public override readonly headline = 'Invalid URL';

  public constructor(paramName: string) {
    super(`Expected URL parameter '${paramName}'`);
    this.name = 'SearchParamError';
  }
}

export class FileNotSupportedError extends HibouError {
  public override readonly headline = 'File not supported';
  public override readonly advice =
    'Please check the file or report the error if it persists.';

  public constructor(creator: string, minVersion: number) {
    super(`Expected HDF5 file created by ${creator} >= ${minVersion}`);
    this.name = 'FileNotSupportedError';
  }
}
